// Import core-js for ES6/ES7 features
import 'core-js/stable';

// Import specific polyfills
import 'custom-event-polyfill';
import 'element-closest-polyfill';
